"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStripeCustomPaymentMethodIdFromCountry = exports.getStripeAccountTokenCompanyFields = exports.getStripeAccountTokenTaxId = exports.getStripeCompanyTaxId = exports.getStripeRepresentativeRelationship = exports.getStripeCompanyStructure = exports.isStripeUboAndDirectorExempt = exports.getStripeBusinessType = exports.getSetupIntentParams = exports.needToCheckPaymentDisabled = exports.getStripeWebhookExpectedApiVersion = exports.getPaymentMethodsList = exports.getAddressAndPhoneForTestModeAutomateOnboardingToStripe = exports.getTestModeBankAccount = exports.stripeTestModeTokens = exports.getStripeFrontendApiKeyFromCountry = exports.getStripeApiKeyFromCountry = exports.doesStripePlatformRequireAccountToken = exports.getCountriesSharingStripePlatform = exports.getStripeProviderKeyFromCountry = void 0;
exports.isAcssDebitSupportedCurrency = isAcssDebitSupportedCurrency;
const enums_1 = require("../../enums");
const country_1 = require("../enums/country");
const currency_1 = require("../enums/currency");
const charity_registration_1 = require("./charity-registration");
const de_fiscal_1 = require("./de-fiscal");
const ein_1 = require("./ein");
const getStripeProviderKeyFromCountry = (country) => {
    switch (country) {
        case country_1.OrganizationCountry.Canada:
            return "stripeCad";
        case country_1.OrganizationCountry.UnitedStates:
            return "stripeUsa";
        case country_1.OrganizationCountry.GreatBritain:
            return "stripeUk";
        case country_1.OrganizationCountry.Australia:
            return "stripeAu";
        case country_1.OrganizationCountry.Ireland:
        case country_1.OrganizationCountry.Germany:
            return "stripeEu";
    }
    throw new Error("Country was not provided on the Stripe provider");
};
exports.getStripeProviderKeyFromCountry = getStripeProviderKeyFromCountry;
const STRIPE_EU_PLATFORM_COUNTRIES = [country_1.OrganizationCountry.Ireland, country_1.OrganizationCountry.Germany];
const getCountriesSharingStripePlatform = (country) => STRIPE_EU_PLATFORM_COUNTRIES.includes(country) ? STRIPE_EU_PLATFORM_COUNTRIES : [country];
exports.getCountriesSharingStripePlatform = getCountriesSharingStripePlatform;
const doesStripePlatformRequireAccountToken = (country) => {
    return (0, exports.getStripeProviderKeyFromCountry)(country) === "stripeEu";
};
exports.doesStripePlatformRequireAccountToken = doesStripePlatformRequireAccountToken;
const getStripeApiKeyFromCountry = (country, stripeConfig) => {
    if (country === country_1.OrganizationCountry.Canada) {
        return stripeConfig.secretKeyCad;
    }
    if (country === country_1.OrganizationCountry.UnitedStates) {
        return stripeConfig.secretKeyUsa;
    }
    if (country === country_1.OrganizationCountry.GreatBritain) {
        return stripeConfig.secretKeyUk;
    }
    if (country === country_1.OrganizationCountry.Australia) {
        return stripeConfig.secretKeyAu;
    }
    if (country === country_1.OrganizationCountry.Ireland || country === country_1.OrganizationCountry.Germany) {
        return stripeConfig.secretKeyEu;
    }
    throw new Error("Country was not provided on the Stripe provider");
};
exports.getStripeApiKeyFromCountry = getStripeApiKeyFromCountry;
const getStripeFrontendApiKeyFromCountry = (country, stripePublicKeys) => {
    if (country === country_1.OrganizationCountry.Australia) {
        return stripePublicKeys.NEXT_PUBLIC_STRIPE_PUBLIC_KEY_AU;
    }
    if (country === country_1.OrganizationCountry.Canada) {
        return stripePublicKeys.NEXT_PUBLIC_STRIPE_PUBLIC_KEY_CA;
    }
    if (country === country_1.OrganizationCountry.GreatBritain) {
        return stripePublicKeys.NEXT_PUBLIC_STRIPE_PUBLIC_KEY_UK;
    }
    if (country === country_1.OrganizationCountry.Ireland || country === country_1.OrganizationCountry.Germany) {
        return stripePublicKeys.NEXT_PUBLIC_STRIPE_PUBLIC_KEY_EU;
    }
    return stripePublicKeys.NEXT_PUBLIC_STRIPE_PUBLIC_KEY_USA;
};
exports.getStripeFrontendApiKeyFromCountry = getStripeFrontendApiKeyFromCountry;
// These are test tokens provided by Stripe to be automatically approved in test mode
// More info: https://docs.stripe.com/connect/testing#creating-accounts
exports.stripeTestModeTokens = {
    addressLine1: "address_full_match​",
    dob: { day: 1, month: 1, year: 1902 },
    taxId: "000000001",
    id_number: "222222222",
    fileIdentity: "file_identity_document_success",
    tos_acceptance: { date: 1609798905, ip: "8.8.8.8" }, // Coming from https://stackoverflow.com/a/70722112
};
const getTestModeBankAccount = (country) => {
    switch (country) {
        case country_1.OrganizationCountry.Canada:
            return { country: "CA", currency: "cad", routing_number: "11000-000", account_number: "000123456789" };
        case country_1.OrganizationCountry.UnitedStates:
            return { country: "US", currency: "usd", routing_number: "110000000", account_number: "000123456789" };
        case country_1.OrganizationCountry.GreatBritain:
            return { country: "GB", currency: "gbp", routing_number: "108800", account_number: "00012345" };
        case country_1.OrganizationCountry.Australia:
            return { country: "AU", currency: "aud", routing_number: "110000", account_number: "000123456" };
        // SEPA country: the IBAN is the full account number, no separate routing number
        case country_1.OrganizationCountry.Ireland:
            return { country: "IE", currency: "eur", routing_number: "", account_number: "IE29AIBK93115212345678" };
        case country_1.OrganizationCountry.Germany:
            return { country: "DE", currency: "eur", routing_number: "", account_number: "DE89370400440532013000" };
        default:
            return { country: "US", currency: "usd", routing_number: "110000000", account_number: "000123456789" };
    }
};
exports.getTestModeBankAccount = getTestModeBankAccount;
const getAddressAndPhoneForTestModeAutomateOnboardingToStripe = (country) => {
    switch (country) {
        case country_1.OrganizationCountry.Canada: {
            return {
                address: {
                    line1: exports.stripeTestModeTokens.addressLine1,
                    city: "Toronto",
                    postal_code: "M4B 1B3",
                    country: "CA",
                    state: "ON",
                },
                phone: "+15062345678",
            };
        }
        case country_1.OrganizationCountry.UnitedStates: {
            return {
                address: {
                    line1: "123 State St", // stripeTestModeTokens.addressLine1 does not work for the US...
                    city: "Schenectady",
                    postal_code: "12345",
                    state: "NY",
                },
                phone: "+12015550123",
            };
        }
        case country_1.OrganizationCountry.GreatBritain: {
            return {
                address: {
                    line1: "123 State St",
                    city: "London",
                    postal_code: "EC1A 1BB",
                    country: "GB",
                    state: "London",
                },
                phone: "+442012345678",
            };
        }
        case country_1.OrganizationCountry.Australia: {
            return {
                address: {
                    line1: "123 State St",
                    city: "Sydney",
                    postal_code: "2000",
                    country: "AU",
                    state: "NSW",
                },
                phone: "+61212345678",
            };
        }
        case country_1.OrganizationCountry.NewZealand: {
            return {
                address: {
                    line1: "123 State St",
                    city: "Auckland",
                    postal_code: "1010",
                    country: "NZ",
                    state: "Auckland",
                },
                phone: "+64212345678",
            };
        }
        case country_1.OrganizationCountry.Ireland: {
            return {
                address: {
                    line1: "123 State St",
                    city: "Dublin",
                    postal_code: "D02 AF30",
                    country: "IE",
                    state: "Dublin",
                },
                phone: "+35312345678",
            };
        }
        case country_1.OrganizationCountry.Germany: {
            return {
                address: {
                    line1: "123 State St",
                    city: "Berlin",
                    postal_code: "10115",
                    country: "DE",
                },
                phone: "+493012345678",
            };
        }
    }
};
exports.getAddressAndPhoneForTestModeAutomateOnboardingToStripe = getAddressAndPhoneForTestModeAutomateOnboardingToStripe;
const getPaymentMethodsList = (country) => {
    if (country === country_1.OrganizationCountry.UnitedStates) {
        return [enums_1.StripeAvailablePaymentMethod.Card, enums_1.StripeAvailablePaymentMethod.Ach, enums_1.StripeAvailablePaymentMethod.CashApp];
    }
    if (country === country_1.OrganizationCountry.Canada) {
        return [enums_1.StripeAvailablePaymentMethod.Card, enums_1.StripeAvailablePaymentMethod.Pad];
    }
    if (country === country_1.OrganizationCountry.GreatBritain) {
        return [enums_1.StripeAvailablePaymentMethod.Card];
    }
    if (country === country_1.OrganizationCountry.Australia) {
        return [enums_1.StripeAvailablePaymentMethod.Card];
    }
    if (country === country_1.OrganizationCountry.Ireland) {
        return [enums_1.StripeAvailablePaymentMethod.Card];
    }
    if (country === country_1.OrganizationCountry.Germany) {
        return [enums_1.StripeAvailablePaymentMethod.Card, enums_1.StripeAvailablePaymentMethod.Sepa];
    }
    return [];
};
exports.getPaymentMethodsList = getPaymentMethodsList;
const CLOVER_API_VERSION = "2025-12-15.clover";
const DAHLIA_API_VERSION = "2026-05-27.dahlia";
const STRIPE_WEBHOOK_API_VERSION_DEFAULT = "2025-09-30.preview";
const getStripeWebhookExpectedApiVersion = (organizationCountry) => {
    if (organizationCountry === country_1.OrganizationCountry.Ireland || organizationCountry === country_1.OrganizationCountry.Germany) {
        return DAHLIA_API_VERSION;
    }
    if (organizationCountry === country_1.OrganizationCountry.Australia) {
        return CLOVER_API_VERSION;
    }
    return STRIPE_WEBHOOK_API_VERSION_DEFAULT;
};
exports.getStripeWebhookExpectedApiVersion = getStripeWebhookExpectedApiVersion;
const needToCheckPaymentDisabled = (country) => {
    return country === country_1.OrganizationCountry.Canada;
};
exports.needToCheckPaymentDisabled = needToCheckPaymentDisabled;
const getSetupIntentParams = (country, online) => {
    if (country === country_1.OrganizationCountry.UnitedStates) {
        return {
            mandate_data: {
                customer_acceptance: {
                    type: "online",
                    online,
                },
            },
        };
    }
    return {};
};
exports.getSetupIntentParams = getSetupIntentParams;
function isAcssDebitSupportedCurrency(currency) {
    return currency === currency_1.AvailablePaymentCurrency.Cad || currency === currency_1.AvailablePaymentCurrency.Usd;
}
const isDeGovernmentEntity = (organization) => organization.country === country_1.OrganizationCountry.Germany &&
    organization.deLegalForm === de_fiscal_1.DeLegalForm.KoerperschaftDesOeffentlichenRechts;
const getStripeBusinessType = (organization) => isDeGovernmentEntity(organization) ? "government_entity" : "non_profit";
exports.getStripeBusinessType = getStripeBusinessType;
const isStripeUboAndDirectorExempt = (organization) => isDeGovernmentEntity(organization);
exports.isStripeUboAndDirectorExempt = isStripeUboAndDirectorExempt;
const DE_LEGAL_FORM_STRIPE_STRUCTURES = {
    [de_fiscal_1.DeLegalForm.EingetragenerVerein]: "incorporated_non_profit",
    [de_fiscal_1.DeLegalForm.Ggmbh]: "incorporated_non_profit",
    [de_fiscal_1.DeLegalForm.Gug]: "incorporated_non_profit",
    [de_fiscal_1.DeLegalForm.Genossenschaft]: "incorporated_non_profit",
    [de_fiscal_1.DeLegalForm.Stiftung]: "unincorporated_non_profit",
    [de_fiscal_1.DeLegalForm.KoerperschaftDesOeffentlichenRechts]: "governmental_unit",
};
const hasIeCroNumber = (charityNumber) => Boolean(charityNumber?.trim()) && (0, ein_1.isIeCroNumberValid)(charityNumber);
const isIeUnincorporatedCharity = (organization) => !hasIeCroNumber(organization.charityNumber) &&
    (0, charity_registration_1.isIeRegisteredCharityNumberValid)(organization.ieRegisteredCharityNumber);
const getStripeCompanyStructure = (organization) => {
    if (organization.country === country_1.OrganizationCountry.GreatBritain) {
        return organization.charityNumber ? undefined : "unincorporated_non_profit";
    }
    if (organization.country === country_1.OrganizationCountry.Australia) {
        return "unincorporated_association";
    }
    if (organization.country === country_1.OrganizationCountry.Ireland) {
        return isIeUnincorporatedCharity(organization) ? "unincorporated_non_profit" : "incorporated_non_profit";
    }
    if (organization.country === country_1.OrganizationCountry.Germany) {
        return organization.deLegalForm ? DE_LEGAL_FORM_STRIPE_STRUCTURES[organization.deLegalForm] : undefined;
    }
    return undefined;
};
exports.getStripeCompanyStructure = getStripeCompanyStructure;
const DE_MEMBER_BASED_LEGAL_FORMS = [
    de_fiscal_1.DeLegalForm.EingetragenerVerein,
    de_fiscal_1.DeLegalForm.Stiftung,
    de_fiscal_1.DeLegalForm.Genossenschaft,
];
const getStripeRepresentativeRelationship = (organization) => {
    if ((0, exports.isStripeUboAndDirectorExempt)(organization)) {
        return { representative: true, owner: false, director: false };
    }
    if (organization.country === country_1.OrganizationCountry.Germany &&
        organization.deLegalForm &&
        DE_MEMBER_BASED_LEGAL_FORMS.includes(organization.deLegalForm)) {
        return { representative: true, owner: false, director: true };
    }
    return { representative: true, owner: true, director: false };
};
exports.getStripeRepresentativeRelationship = getStripeRepresentativeRelationship;
const getStripeCompanyTaxId = (organization) => {
    if (!organization.charityNumber) {
        return undefined;
    }
    if (organization.country === country_1.OrganizationCountry.UnitedStates) {
        return organization.charityNumber.replace(/-/g, "").padStart(9, "0");
    }
    if (organization.country === country_1.OrganizationCountry.Ireland) {
        return organization.charityNumber.trim().toUpperCase();
    }
    return organization.charityNumber;
};
exports.getStripeCompanyTaxId = getStripeCompanyTaxId;
// Only Ireland needs tax_id in the account token (CRO registry check); Germany goes through getStripeAccountTokenCompanyFields.
const getStripeAccountTokenTaxId = (organization) => {
    if (organization.country !== country_1.OrganizationCountry.Ireland) {
        return undefined;
    }
    if (!hasIeCroNumber(organization.charityNumber)) {
        return undefined;
    }
    return (0, exports.getStripeCompanyTaxId)(organization);
};
exports.getStripeAccountTokenTaxId = getStripeAccountTokenTaxId;
const getStripeAccountTokenCompanyFields = (organization) => {
    if (organization.country === country_1.OrganizationCountry.Ireland) {
        const taxId = (0, exports.getStripeAccountTokenTaxId)(organization);
        return taxId ? { tax_id: taxId } : {};
    }
    if (organization.country === country_1.OrganizationCountry.Germany) {
        if (!(0, de_fiscal_1.getDeRegisterType)(organization.deLegalForm)) {
            return {};
        }
        const registerNumber = (0, de_fiscal_1.formatDeRegisterNumberForStripe)(organization.charityNumber);
        return registerNumber ? { tax_id: registerNumber } : {};
    }
    return {};
};
exports.getStripeAccountTokenCompanyFields = getStripeAccountTokenCompanyFields;
const getStripeCustomPaymentMethodIdFromCountry = (country, idsByCountry) => {
    switch (country) {
        case country_1.OrganizationCountry.Canada:
            return idsByCountry.canada;
        case country_1.OrganizationCountry.UnitedStates:
            return idsByCountry.unitedStates;
        case country_1.OrganizationCountry.GreatBritain:
            return idsByCountry.greatBritain;
        case country_1.OrganizationCountry.Australia:
            return idsByCountry.australia;
        case country_1.OrganizationCountry.Ireland:
            return idsByCountry.ireland;
        case country_1.OrganizationCountry.Germany:
            return idsByCountry.germany;
        default:
            return undefined;
    }
};
exports.getStripeCustomPaymentMethodIdFromCountry = getStripeCustomPaymentMethodIdFromCountry;
